export const rollcallleavetypes = [
  {
    id: 1,
    Name: "Casual Leave",
    Abbreviation: "CL",
    date_created: "10/01/23",
    Status: "Active",
  },
  {
    id: 2,
    Name: "Paid Leave",
    Abbreviation: "PL",
    date_created: "15/12/22",
    Status: "Active",
  },
  {
    id: 3,
    Name: "Sick Leave",
    Abbreviation: "SL",
    date_created: "05/02/23",
    Status: "Active",
  },
  {
    id: 4,
    Name: "Maternity Leave",
    Abbreviation: "ML",
    date_created: "20/11/22",
    Status: "Active",
  },
  {
    id: 5,
    Name: "Paternity Leave",
    Abbreviation: "PTL",
    date_created: "01/03/23",
    Status: "Active",
  },
  {
    id: 6,
    Name: "Bereavement Leave",
    Abbreviation: "BL",
    date_created: "12/04/23",
    Status: "Inactive",
  },
];
